import type { AdminVehicleGenerationDto, VehicleCatalogEntryStatus } from '@carcheck/shared';
import { useTranslation } from 'react-i18next';

import type { UseCatalogWriteResult } from './useCatalogWrite';
import { patchCatalogGeneration } from '../../../api/admin-vehicle-generations';
import { publishToast } from '../../../components/feedback';

/**
 * Скрыть / Показать one generation (AUT-450 / VG-03) — saves at once:
 * `PATCH /generations/:id {updatedAt, status}` with the row's `updatedAt`
 * verbatim. Also the conflict's «Показать снова» (the hidden holder of the
 * key). The runner refetches the list and the make (`generationCount`); a
 * stale 409 → a toast, the fresh row is already loaded. Resolves `true` on
 * success.
 */
const STALE_TOAST_MS = 6000;
const K = 'vehicleCatalog.generations';

export const useGenerationStatus = (
  write: UseCatalogWriteResult,
): ((g: AdminVehicleGenerationDto, status: VehicleCatalogEntryStatus) => Promise<boolean>) => {
  const { t } = useTranslation();
  return async (g, status) => {
    const outcome = await write.run(
      () => patchCatalogGeneration(g.id, { updatedAt: g.updatedAt, status }),
      { successKey: status === 'hidden' ? `${K}.hiddenOk` : `${K}.shownOk` },
    );
    if (!outcome.ok && outcome.error.kind === 'stale') {
      publishToast({
        severity: 'warning',
        durationMs: STALE_TOAST_MS,
        message: t(`${K}.staleToast`),
      });
    }
    return outcome.ok;
  };
};
